// Battery.js (Corrected)
import React from 'react';

// This component renders the battery icon.
// Its internal coordinates are now relative to its own group, making it easy to place.
const Battery = ({ bars, activeColor, totalBars = 6 }) => {
    const barHeight = 12;
    const barGap = 5;
    // Start Y position for the first bar, relative to the top of the component
    const startY = 23;

    return (
            <g>
                {/* Battery Body and Cap, with y-coordinates starting near 0 */}
                <rect x="0" y="5" width="60" height="130" rx="10" stroke="#7B6F9A" strokeWidth="2.5" fill="none" />
                <rect x="17" y="0" width="26" height="5" rx="3" fill="#7B6F9A" />

                {/* Dynamic Battery Bars */}
                {Array.from({ length: totalBars }).map((_, index) => {
                    // We now count from the top down to fill bars
                    const isFilled = index >= totalBars - bars;
                    const yPos = startY + index * (barHeight + barGap);

                    return (
                            <rect
                                    key={index}
                                    x="10"
                                    y={yPos}
                                    width="40"
                                    height={barHeight}
                                    rx="2"
                                    fill={isFilled ? activeColor : 'none'}
                                    stroke={isFilled ? 'none' : '#4A2E5B'}
                                    strokeWidth="1.5"
                            />
                    );
                })}
            </g>
    );
};

export default Battery;